import Cropper from './Cropper';
import Preview from './Preview';

Cropper.Preview = Preview;

export default Cropper;
